var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag copy-s bold"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n    "),(_vm.removable)?_c('FeatherIcon',{attrs:{"name":"x"},on:{"click":function($event){return _vm.$emit('remove', _vm.value)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }